//var featureDetector = require('ismobilejs');

var GPT_NETWORK_CODE = '75548861';
var REGEX_ZONE_SCRUB = /([\$\-\_\+\!\*\'\(\),\" ])/gi;
var responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit');


/**
 * sitename specific to emdunds for ad from google (gpt)
 * @param {Object} pageValues page level values
 * @param {String} pageValues.name edw page name
 * @param {Object} pageValues.category edw page category
 * @param {Object} pageValues.vehicle page level vehicle object
 * @param {Object} pageValues.inventory page level inventory object
 *
 * @returns {string}
 */
var _generate = function(pageValues) {
    var localPageValues = _addAgnosticToYear(pageValues);
    var zones = _determineZones(localPageValues);
    return zones.join('/')
        .replace(REGEX_ZONE_SCRUB, '')
        .toLowerCase();
};

/*
 * Generate gptApp name 'mobile' or 'wired'
 *
 * @returns {string}
 */
function _getGptApp() {
    if(responsiveToolkit.is('<=sm')){
        return 'mobile';
    }
    return 'wired';
}

function _determineZones(pageValues) {
    var usecases = _getUseCases();
    var zones = [GPT_NETWORK_CODE];
    var usecase;
    for (var i = 0, len = usecases.length; i < len; i++) {
        usecase = usecases[i](pageValues, zones);
        if (usecase) {
            return usecase;
        }
    }

    return [];
}

function _handlePublicationState(ps) {
    var _ps = (typeof ps === 'string') ? ps.toLowerCase() : 'new';
    if(_ps === 'new_used' || _ps === 'future') {
        _ps = 'new';
    }
    return _ps;
}

function _handleInventoryType(inventoryTypes) {
    var type = '';
    if (inventoryTypes && inventoryTypes.length) {
        if (inventoryTypes.indexOf('NEW') !== -1) {
            type = 'new';
        } else if (inventoryTypes.indexOf('CPO') !== -1) {
            type = 'cpo';
        } else if (inventoryTypes.indexOf('USED') !== -1) {
            type = 'used';
        }
    }
    return type + 'carinventory';
}

function _getUseCases() {
    return [
        _modelUseCase,
        _makeUseCase,
        _typeUseCase,
        _invUseCase,
        _hpUseCase,
        _defaultUseCase
    ];
}

function _hpUseCase(pageValues, zones) {
    if (pageValues.page.category &&
        pageValues.page.category === 'home_page') {
        var str = [_getGptApp(), 'homepage'].join('.');
        return zones.concat([str]);
    }
    return null;
}

function _invUseCase(pageValues, zones) {
    if (pageValues.page.category &&
        pageValues.page.category === 'car_inventory') {
        return zones.concat([_getGptApp(), _handleInventoryType(pageValues.inventory.inventoryTypes), 'srp']);
    }
    return null;
}

function _defaultUseCase(pageValues, zones) {
    return zones;
}

function _typeUseCase(pageValues, zones) {
    if (pageValues.vehicle && pageValues.vehicle.type.niceName) {
        var str = [_getGptApp(), 'new', 'type'].join('.');
        return zones.concat([str, pageValues.vehicle.type.niceName]);
    }

    return null;
}

function _makeUseCase(pageValues, zones) {
    if (pageValues.vehicle && pageValues.vehicle.make.niceName) {
        var str = [_getGptApp(), _handlePublicationState(pageValues.vehicle.publicationState), 'make'].join('.');
        return zones.concat([str, pageValues.vehicle.make.niceName, pageValues.vehicle.modelYear.year]);
    }

    return null;
}

function _modelUseCase(pageValues, zones) {
    if (pageValues.vehicle && pageValues.vehicle.subModel.niceName || pageValues.vehicle.model.niceName) {
        var str = [_getGptApp(), _handlePublicationState(pageValues.vehicle.publicationState), 'mdl'].join('.');
        return zones.concat([str, pageValues.vehicle.modelYear.year, pageValues.vehicle.make.niceName]);
    }

    return null;
}

function _addAgnosticToYear(pageValues) {
    var pageValuesCopy = pageValues;
    var yearValue = pageValues.vehicle.modelYear.year ? pageValues.vehicle.modelYear.year : '';
    //Set default value (agnostic) for case of multiple or empty values of years
    if (yearValue != 'agnostic' && (yearValue === '' || yearValue.length != 4)) {
        pageValuesCopy = $.extend({}, {}, pageValues);
        pageValuesCopy.vehicle.modelYear.year = 'agnostic';
    }
    return pageValuesCopy;
}

module.exports = _generate;



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-context/sitename-generator.js
// module id = 442
// module chunks = 36